/* video-slider.js - the play behaviour of sections/video-slider.liquid.

   2026-09-25: ONE AT A TIME AGAIN, AND A CENTRE TO PLAY. The merchant picked
   the reels design of state/mocks/2026-09-25/01-reels.html: a coverflow stage
   from 1024px ("Center stage: one big reel") and a centre snapped rail below
   ("The rail: five reels in a row, one plays"). Both layouts have ONE centre
   reel, this file owns which one it is (`go()`), and the centre is the one
   that plays: AMBIENT_MAX_WIDE drops from three to one, which also answers the
   "everything autoloads" report. The sources stay attached at build time under
   `preload="none"`: MEASURED on the dev theme at 1440 and 390, a reel that
   never becomes the centre fetches no video byte (1 file for 1 centre, 2 for
   2), and attaching them late would blind state/tools/verify-video-autoplay.mjs
   M3, whose "everything plays" mutation calls play() on every player. The
   paragraphs below keep their history; where they say "three" on a computer,
   read "one, the centre".

   F7 IS REVERSED, AT THE MERCHANT'S REQUEST, 2026-09-18. This file used to end
   its first paragraph with "Never autoplay, never muted, never looped." That
   sentence is gone because the merchant asked for the opposite, verbatim:

     "je veux que les videos autoplay et que ca fasse vraiemnt effet instal un
      peu, je suis sur que tu peux retravailler ca un peu"

   So the row now runs an AMBIENT loop, the way a feed does. What survives of
   F7 is the half that was never about taste: a visitor who takes hold of a
   slide is not overruled by the observer. Unmuting a slide CLAIMS it, and a
   claimed slide keeps playing while it is on screen, is never pushed aside by
   the pointer, and is never re-muted under the visitor. The other half of F7,
   "no sound without a press", is enforced by the browser now rather than by
   this file: see below.

   MUTED IS NOT A CHOICE, IT IS THE ONLY AUTOPLAY THERE IS. No browser starts a
   video with sound before a gesture, so the ambient player ships the whole
   quartet `muted loop playsinline preload="none"`. `playsinline` is not
   decoration: without it Safari on iOS takes the video fullscreen the moment it
   starts, which would replace the home page with a video player. Sound comes
   back only through the per slide control, and only one slide at a time can
   hold it: claiming one mutes every other.

   HOW MANY SLIDES PLAY AT ONCE IS A MEASURED TRADE, AND SINCE 2026-09-19 IT IS
   TWO NUMBERS RATHER THAN ONE. Shopify hands Liquid two sources per video, an
   HLS playlist and one MP4, and the MP4 it hands over is the HEAVIEST rendition:
   measured 2026-09-19, the file behind the giveaway's second `<source>` is
   `HD-1080p-2.5Mbps`, 3 267 839 octets for a 9 s clip, and NOT the
   `HD-720p-1.6Mbps` that blocks/video-slide.liquid's own comment names. The
   playlist is the better card because it is adaptive and fetched segment by
   segment, and it is what actually gets played in BOTH engines: measured the
   same day on the dev theme, `currentSrc` ends in `.m3u8` in Chromium as well as
   in WebKit, and the segments come off a 480p/720p/1080p ladder Liquid never
   exposes.

   ONE WAS THE CAP UNTIL 2026-09-19, AND THE MERCHANT REPORTED IT AS A DEFECT:
   "sur ordi les video ne s'auto play pas automatiquement". Measured before
   changing anything, dev theme, home page, row parked in the fold, Chromium AND
   WebKit, 1440x900 and 1920x1080: ONE video played every time, the centred one,
   and its play() RESOLVED. Zero never happened. The behaviour was not broken,
   so the fix is not in the player: what the merchant saw is the other FOUR
   verticals frozen on their posters, which on a five column desktop row does not
   read as a feed. The cap is what has to move.

   WHAT THE CAP COSTS, MEASURED 2026-09-19, Chromium, 10 s parked in the fold,
   the real policy (the served asset's constant rewritten at the edge, so DWELL,
   the teaser cap and pick()'s ranking all still applied), media bytes only:

     cap 1 ....  2 931 313 octets (8 req)  at 1440 ....  3 480 767 (7)  at 1920
     cap 3 .... 12 154 805 octets (23 req) at 1440 .... 12 154 528 (23) at 1920
     cap 5 .... 22 526 099 octets (40 req) at 1440 .... 22 525 703 (40) at 1920
     the home page itself, not one video .....  4 781 807 octets transferred

   Three is 4.1 times one and 54 percent of five; five is 4.7 times the whole
   page. Playing a vignette at all costs roughly the WHOLE clip: these are 9 to
   15 s verticals at ~2.5 Mbps, and the byte reading at t+1 s is already the
   reading at t+10 s. So there is no cheaper "this tile is alive" to be had by
   shortening the teaser either, and the cap is the only dial with a real range.

   THE LADDER IS NOT A LEVER, WHICH WAS WORTH MEASURING BEFORE BELIEVING. The
   obvious saving is to stop a 233 CSS px vignette from climbing to a 606x1080
   rung. Measured the same day by trimming the master playlist at the edge to a
   single variant: a one variant playlist is REFUSED by the engine, which falls
   through to the second `<source>` and downloads the 1080p MP4 whole, i.e. MORE
   bytes than it started with. Where the trim did take, a pinned 480p loop still
   cost 2.0 to 2.2 Mo per vignette per 10 s against 2.9 unpinned: 30 percent, for
   a playlist fetch, a parse and a fallback path per tile. Not worth it.

   SO: THREE FROM 1024px, ONE BELOW. On a phone the row shows one column and a
   half, only one vertical is really legible, and one is exactly the feed
   gesture: the snapped slide plays and the others wait. From 1024px the row
   shows five columns at once, so three of them loop and the POINTER promotes
   whichever one it passes over INTO the trio rather than replacing it. The
   9.2 Mo that buys is spent only by a visitor who scrolled 1 472 px down the
   home page and then held still for DWELL milliseconds, and it is released the
   moment the row leaves the viewport. If the merchant ever wants all five, the
   number is AMBIENT_MAX_WIDE and the price is 22.5 Mo, measured, not guessed.

   ONE VIDEO IS NOT A BUDGET ON ITS OWN, WHICH IS WHY THERE IS A TEASER CAP. The
   first vignette is the giveaway, 24.4 s, and it is the one a phone plays. With
   the loop left to run its whole length, MEASURED at 390 on the dev theme,
   the playlist keeps climbing its ladder and re-fetching across the loop:

     giveaway, HLS, full loop ......  4 308 873 at 3 s, 6 854 429 at 10 s,
                                     14 906 501 at 30 s, STILL CLIMBING
     giveaway, MP4 only, full loop .  8 124 820 at 30 s, the whole file, once
     giveaway, HLS, rewound at 8 s .  4 308 873 at 3 s, 6 854 429 at 10 s,
                                      6 854 429 at 30 s, FLAT

   Rewinding is the only one of the three that PLATEAUS, and it is half the cost
   of letting the loop run. So a clip longer than `TEASER` seconds plays its
   first `TEASER` seconds on repeat; a shorter one loops whole and is untouched.
   That is a teaser, which is what a feed shows anyway, and pressing the
   vignette still plays the video in full with its sound. The renditions are
   also why the MP4 is not used for the loop: the one Liquid exposes is the
   HEAVIEST, measured 606x1080 for a vignette 233 CSS px wide.

   AND NOTHING STARTS FOR A VISITOR PASSING THROUGH. A slide has to stay
   eligible for `DWELL` milliseconds before it plays, so scrolling past the row
   costs nothing at all rather than the first seconds of a video nobody saw.

   THE AMBIENT PLAYER LIVES IN A SHADOW ROOT, AND THAT IS STILL LOAD BEARING.
   assets/slider.js drives the same track and its `media()` calls play() on the
   `<video>` of whichever slide sits at the snap index, and pause() on every
   other. MEASURED the same day: an ambient `<video>` put in the light DOM of a
   slide had its play() rejected with AbortError, because slider.js paused it
   under us. `slide.querySelector('video')` does not cross a shadow boundary, so
   the player is built behind one and this file is its only driver. The two
   scripts still never argue.

   NOTHING PLAYS THAT IS NOT WANTED. Reduced motion builds no ambient player at
   all: the poster stays and playback is a press, which is the behaviour this
   file shipped with. A hidden tab pauses. A slide that leaves the viewport is
   paused AND rewound, which is what stops the row from filling a buffer for
   something nobody is looking at, and which is why `preload="none"` is not
   enough on its own.

   THE SLIDE STILL SHIPS NO PLAYER FROM LIQUID. blocks/video-slide.liquid
   renders a poster and a plain link: to the video on TikTok, or to the MP4
   itself for a file uploaded to Shopify (its renditions ride along as JSON in
   data-video-sources). Everything above is built here, so a visitor without
   this file still meets a real destination instead of a dead play button.

   TWO PLAYERS, TWO JOBS. The ambient loop is a teaser: muted, looping, no
   controls, decorative. A press upgrades the slide to the full player, an
   iframe for TikTok and a `<video controls>` for the file, unmuted and from the
   top. While that player is up the whole row stops looping, and teardown hands
   the row back.

   ONE FULL PLAYER AT A TIME, AND NONE OFF SCREEN. A cross origin TikTok frame
   cannot be paused from the parent document without loading TikTok's own SDK,
   so the only honest way to stop the sound is to REMOVE the frame. Teardown IS
   the pause here: the poster comes back and the position in the video is lost.
   That trade is exactly why the frame is built on demand instead of kept around
   muted and hidden.

   THE CLOSE BUTTON IS NOT DECORATION. Once focus is inside a cross origin
   frame, Escape belongs to TikTok and never reaches the keydown listener below,
   so the button that follows the frame in tab order is the only exit a keyboard
   visitor has. It ships `hidden` from Liquid and is unhidden here, so it is
   never a dead control for a visitor without JavaScript. The sound control
   ships `hidden` for the same reason: without this file there is nothing to
   mute.

   No `sandbox` attribute: the embed is TikTok's own player and a guessed
   allow list breaks playback silently, which is worse than not narrowing it.

   A custom element, not a shopify:section:load listener: the editor replaces a
   section's innerHTML, which alone disconnects this instance and upgrades the
   replacement, so there is no teardown left to go looking for. */
(() => {
  'use strict';
  if (customElements.get('pp-video-slider')) return;

  const EMBED = 'https://www.tiktok.com/embed/v2/';
  const motion = window.matchMedia('(prefers-reduced-motion: reduce)');

  /* The two caps argued in the header. One below 1024px, where a column and a
     half is on screen and a single legible vertical IS the feed gesture. Three
     from 1024px, where five columns are on screen at once and one moving tile
     out of five is what the merchant reported as "les video ne s'auto play pas":
     measured 12 154 805 octets over 10 s against 22 526 099 for all five, and
     2 931 313 for one. Raising either number costs bytes on the curve the header
     measures, so measure again before moving one.

     AMBIENT_MAX keeps its name and its place as the FIRST of the two, because
     state/tools/verify-video-autoplay.mjs reads the policy out of this file
     rather than carrying a number of its own. That bench now needs the second
     number too: it derives its expectation from one constant and therefore
     expects one player at 1440 where three now run. It is a judge, not a
     product file, so it is not touched from here. */
  const AMBIENT_MAX = 1;
  const AMBIENT_MAX_WIDE = 1;

  /* The SAME predicate the section's stylesheet uses. sections/video-slider.liquid
     switches `.video-slider__track > *` from --pp-vs-columns-mobile to
     --pp-vs-columns inside `@media (min-width: 1024px)`, so 1024 is exactly the
     width at which the row stops showing a column and a half and shows its five.
     Reading the media query instead of comparing innerWidth to a neighbouring
     number is what keeps the cap tied to the column count: if the stylesheet's
     breakpoint ever moves, one edit moves both. It is also the only width source
     that cannot be inflated the way innerWidth is under an emulated mobile
     viewport. */
  const wide = window.matchMedia('(min-width: 1024px)');

  /* Two presses on the same playing reel inside this window are a double tap:
     the heart bursts and the rail's heart fills, on this page only. */
  const DOUBLE_TAP = 350;

  /* The teaser cap argued in the header, in seconds. A clip shorter than this
     loops whole; a longer one repeats its opening. Raising it costs bytes on a
     curve the header measures, so measure again before moving it. */
  const TEASER = 10;

  /* How long a slide has to stay the chosen one before it is allowed to play.
     Long enough that a scroll straight past the row downloads nothing, short
     enough that a visitor who stops does not notice a wait. */
  const DWELL = 300;

  /* A slide has to be half on screen before it is allowed to play. Below that
     it is the sliver of the next vertical peeking past the snap, and starting
     a video there is a download for something the visitor has not reached. */
  const VISIBLE_MIN = 0.5;

  /* Enough thresholds that a horizontal swipe re ranks the row while it moves
     rather than only at the ends. The ratio is a gate, not the ranking: at a
     width where every column is on screen all five sit at 1 and the ranking is
     done on distance to the middle of the viewport instead. */
  const STEPS = [0, 0.25, 0.5, 0.75, 1];

  /* An embeddable src, or null when the href is not a TikTok video we can
     address. A shortened vm.tiktok.com link only resolves by following a
     redirect, which is not this file's job, so it stays a plain link out. */
  function embedSrc(href) {
    let url;
    try {
      url = new URL(href, window.location.href);
    } catch (error) {
      return null;
    }
    if (url.protocol !== 'https:' && url.protocol !== 'http:') return null;
    const host = url.hostname.toLowerCase();
    if (host !== 'tiktok.com' && !host.endsWith('.tiktok.com')) return null;
    const found = url.pathname.match(/\/(?:video|embed(?:\/v\d+)?)\/(\d{6,})(?:\/|$)/);
    return found ? EMBED + found[1] : null;
  }

  /* The renditions of a Shopify hosted file, or null when the link carries
     none. Only http(s) or protocol relative sources with a MIME type survive
     (Shopify prints its CDN URLs as //host/path): the attribute is merchant
     data printed by Liquid, and a <source> with no type would make the browser
     probe it. Order is kept: Shopify lists the HLS playlist first and the MP4
     renditions after it, and a browser takes the first it can play, which is
     how video_tag orders them too, and which is what gives the ambient loop its
     adaptive ladder wherever the browser reads a playlist. */
  function fileSources(raw) {
    if (!raw) return null;
    let list;
    try {
      list = JSON.parse(raw);
    } catch (error) {
      return null;
    }
    if (!Array.isArray(list)) return null;
    const kept = list.filter((item) => {
      if (!item || typeof item.url !== 'string' || typeof item.mime_type !== 'string') return false;
      return /^(?:https?:)?\/\//i.test(item.url);
    });
    return kept.length ? kept : null;
  }

  /* Builds the sources of a player from the list, in the order they arrived. */
  function fill(video, sources) {
    sources.forEach((item) => {
      const source = document.createElement('source');
      source.src = item.url;
      source.type = item.mime_type;
      video.append(source);
    });
  }

  /* L'URL de poster a donner a un lecteur: celle que l'`<img>` du poster a
     REELLEMENT telechargee, sinon celle que Liquid a ecrite. `currentSrc` et pas
     `src`: `src` rend l'URL de repli du tag, jamais l'entree choisie dans le
     srcset, et c'est l'entree choisie qui est dans le cache. Vide tant que
     l'image paresseuse n'a pas charge, d'ou le repli. */
  function posterFor(frame, trigger) {
    const img = frame ? frame.querySelector('.video-slide__poster img') : null;
    if (img && img.currentSrc) return img.currentSrc;
    return trigger ? trigger.getAttribute('data-video-poster') : null;
  }

  /* The style the shadow root needs and nothing more: a stylesheet does not
     reach inside it. No colour, the poster and the frame behind it draw the box. */
  const PLAYER_STYLE = ':host{display:block}video{display:block;width:100%;height:100%;object-fit:cover}';

  class VideoSlider extends HTMLElement {
    connectedCallback() {
      this.frame = null;
      this.trigger = null;
      this.video = null;
      this.loops = [];
      this.rank = null;
      this.hovered = null;
      this.wait = 0;
      this.armed = null;
      this.onPress = (event) => this.press(event);
      this.onKey = (event) => {
        if (event.key === 'Escape' && this.frame) this.stop(true);
      };
      this.onHide = () => {
        if (document.hidden) this.stop();
        this.pick();
      };
      /* pointerType is the guard: a tap fires pointerover too, and a phone that
         "hovered" the slide it was scrolled past would pin playback there. */
      this.onOver = (event) => {
        if (event.pointerType !== 'mouse') return;
        const frame = event.target && event.target.closest
          ? event.target.closest('[data-video-frame]')
          : null;
        if (frame === this.hovered) return;
        this.hovered = frame;
        this.pick();
      };
      this.onOut = (event) => {
        if (event.pointerType !== 'mouse') return;
        if (this.contains(event.relatedTarget)) return;
        this.hovered = null;
        this.pick();
      };
      this.onMotion = () => {
        this.loop();
        this.pick();
      };
      /* Crossing 1024px changes the cap, so it has to change what is playing.
         pick() and not loop(): a player is built for every slide whatever the
         width, only the number of them chosen moves, and pick() already rests
         whatever falls out of the slice when a window narrows. */
      this.onWide = () => {
        this.go(this.center);
        this.fold();
      };
      this.onFocus = (event) => {
        const target = event.target;
        if (!target || !target.matches || !target.matches(':focus-visible')) return;
        const index = this.slides.findIndex((slide) => slide.contains(target));
        if (index !== -1 && index !== this.center) this.go(index);
      };
      this.onScroll = () => {
        if (this.ticking || wide.matches) return;
        this.ticking = true;
        window.requestAnimationFrame(() => {
          this.ticking = false;
          const index = this.nearest();
          if (index === -1 || index === this.center) return;
          this.center = index;
          this.layout();
          this.pick();
        });
      };
      this.addEventListener('click', this.onPress);
      this.addEventListener('focusin', this.onFocus);
      this.addEventListener('keydown', this.onKey);
      this.addEventListener('pointerover', this.onOver);
      this.addEventListener('pointerout', this.onOut);
      document.addEventListener('visibilitychange', this.onHide);
      motion.addEventListener('change', this.onMotion);
      wide.addEventListener('change', this.onWide);
      this.watcher = new IntersectionObserver((entries) => {
        if (!entries[entries.length - 1].isIntersecting) this.stop();
      });
      this.watcher.observe(this);
      this.stage();
      this.loop();
      this.pick();
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onPress);
      this.removeEventListener('focusin', this.onFocus);
      if (this.track) this.track.removeEventListener('scroll', this.onScroll);
      this.removeEventListener('keydown', this.onKey);
      this.removeEventListener('pointerover', this.onOver);
      this.removeEventListener('pointerout', this.onOut);
      document.removeEventListener('visibilitychange', this.onHide);
      motion.removeEventListener('change', this.onMotion);
      wide.removeEventListener('change', this.onWide);
      if (this.watcher) this.watcher.disconnect();
      this.watcher = null;
      this.unloop();
      this.stop();
    }

    /* ---- the ambient loops --------------------------------------------- */

    /* One muted looping player per slide that has a Shopify hosted file, built
       once and kept. A TikTok slide gets none: there is nothing to loop without
       loading TikTok's frame, which is the one thing this row refuses to do
       before a press. */
    loop() {
      this.unloop();
      if (motion.matches) return;
      [...this.querySelectorAll('[data-video-frame]')].forEach((frame) => {
        const trigger = frame.querySelector('[data-video-play]');
        if (!trigger) return;
        const sources = fileSources(trigger.getAttribute('data-video-sources'));
        if (!sources) return;

        const host = document.createElement('div');
        host.className = 'video-slide__ambient';
        /* Decorative: the caption names the video and the link carries the
           destination, so a second announcement of the same slide is noise. */
        host.setAttribute('aria-hidden', 'true');
        const root = host.attachShadow({ mode: 'open' });
        const style = document.createElement('style');
        style.textContent = PLAYER_STYLE;

        const video = document.createElement('video');
        video.muted = true;
        /* defaultMuted writes the ATTRIBUTE, which is what an engine reads when
           it decides whether an autoplay is allowed to start at all. */
        video.defaultMuted = true;
        video.loop = true;
        video.playsInline = true;
        video.preload = 'none';
        video.controls = false;
        video.disableRemotePlayback = true;
        video.setAttribute('muted', '');
        video.setAttribute('playsinline', '');
        video.setAttribute('loop', '');
        /* PAS DE POSTER SUR LE LECTEUR AMBIANT, ET C'EST UNE REQUETE D'IMAGE EN
           MOINS PAR TUILE POUR TOUT LE MONDE. Il portait `data-video-poster`, que
           Liquid ecrit a `width: 720`, tandis que l'`<img>` du poster choisit sa
           marche dans son propre srcset. MESURE 2026-09-19 au 1440x900 DPR 1: le
           navigateur sert 720w sur trois tuiles et 360w sur les deux autres, a
           largeur CSS IDENTIQUE (255 px) et `sizes` identique, parce que les cinq
           posters n'ont pas la meme taille intrinseque; et a DPR 2 tout remonte
           d'un cran. AUCUNE largeur fixe ecrite en Liquid ne peut donc coller.

           ET LE MECANISME N'ETAIT PAS CELUI QU'ON CROIT, MESURE APRES COUP. Ce
           poster ne DOUBLAIT pas l'image, il TIRAIT L'AUTRE VERS LE HAUT: la
           demande a 720 arrivait dans le cache avant que l'`<img>` ne choisisse,
           et un navigateur prefere une entree de srcset deja en cache. Les trois
           posters qui ont une marche 720 etaient donc servis en 720 a l'`<img>`
           aussi, pour une vignette de 255 px de large. Mesure apres le retrait:
           les cinq se posent tous sur 360, soit 187 940 octets pour les cinq,
           contre 240 366 pour les trois gros seuls en 720, et les cinq requetes
           de poster ont disparu avec.

           Le poster n'est donc pas realigne, il est RETIRE, parce qu'il etait
           redondant: `.video-slide__ambient` est en `z-index: 1` par-dessus
           `.video-slide__poster`, donc l'`<img>` deja telechargee se voit a
           travers un `<video>` qui n'a encore decode aucune image. C'est ce que la
           feuille de style du bloc promet depuis le debut ("It covers the poster
           rather than replacing it"). Un autoplay refuse, un fichier qui ne decode
           pas, `prefers-reduced-motion`: dans les trois cas l'image reste, et elle
           est servie UNE fois, a la marche que le navigateur a choisie lui-meme.
           A verifier au rendu, parce que c'est la seule chose qui pourrait mal
           tourner ici: qu'aucune tuile ne peigne du noir avant sa premiere image. */
        /* The teaser cap. `loop` still handles anything shorter than the cap, so
           this only ever fires on the long clips, which are the ones that cost.
           timeupdate rather than a timer: it is the only clock that follows the
           video's own progress through a stall or a rebuffer. */
        video.addEventListener('timeupdate', () => {
          if (video.duration > TEASER && video.currentTime >= TEASER) video.currentTime = 0;
          const span = Math.min(video.duration || 0, TEASER);
          if (span) frame.style.setProperty('--pp-reel-progress', String(Math.min(1, video.currentTime / span)));
        });
        fill(video, sources);
        root.append(style, video);

        frame.prepend(host);
        frame.setAttribute('data-video-ambient', '');
        const sound = frame.querySelector('[data-video-sound]');
        if (sound) sound.hidden = false;
        this.loops.push({ frame, host, video, claimed: false });
      });

      if (!this.loops.length) return;
      this.rank = new IntersectionObserver(() => this.pick(), { threshold: STEPS });
      this.loops.forEach((item) => this.rank.observe(item.frame));
    }

    unloop() {
      if (this.rank) this.rank.disconnect();
      this.rank = null;
      this.loops.forEach((item) => {
        item.video.pause();
        item.host.remove();
        item.frame.removeAttribute('data-video-ambient');
        item.frame.removeAttribute('data-video-ambient-playing');
        const sound = item.frame.querySelector('[data-video-sound]');
        if (sound) sound.hidden = true;
      });
      clearTimeout(this.wait);
      this.wait = 0;
      this.armed = null;
      this.loops = [];
      this.hovered = null;
    }

    /* The one place a loop starts or stops, so the observer, the pointer, the
       sound control and the full player cannot disagree about who is playing.

       Ranking, in order: a slide the visitor CLAIMED by unmuting it wins while
       it is still on screen, then the slide under the pointer, then the one
       closest to the middle of the viewport. Everything past the cap rests. */
    pick() {
      if (!this.loops.length) return;
      const width = window.innerWidth || document.documentElement.clientWidth;
      const height = window.innerHeight || document.documentElement.clientHeight;

      const scored = this.loops.map((item) => {
        const box = item.frame.getBoundingClientRect();
        const across = Math.max(0, Math.min(box.right, width) - Math.max(box.left, 0));
        const down = Math.max(0, Math.min(box.bottom, height) - Math.max(box.top, 0));
        const area = box.width * box.height;
        return {
          item,
          seen: area ? (across * down) / area : 0,
          off: Math.abs((box.left + box.right) / 2 - width / 2),
        };
      });

      let wanted = [];
      /* The full player owns the row while it is up, and a hidden tab plays
         nothing at all. Reduced motion never reaches here with loops built, but
         the guard costs a boolean and survives a future caller. */
      if (!this.frame && !document.hidden && !motion.matches) {
        const cap = wide.matches ? AMBIENT_MAX_WIDE : AMBIENT_MAX;
        const hot = (row) => row.item.frame === this.hovered;
        const centre = this.slides[this.center];
        const lead = (row) => Boolean(centre && centre.contains(row.item.frame));
        /* ONE COMPARATOR, NOT THREE POOLS, AND THAT CHANGED WITH THE CAP. While
           the cap was 1 this read as "claimed tiles, else hovered tiles, else
           everything", each stage REPLACING the pool, and with one slot that
           happens to give the right answer. With three slots it gives the wrong
           one twice over: claiming a tile with the sound control would have
           narrowed the pool to that tile and STOPPED the other two, and moving
           the pointer onto a tile would have done the same. Both read as the row
           dying under the visitor's own gesture, which is the opposite of what
           either gesture asks for. So claimed and hovered now ORDER the same
           pool instead of shrinking it: a claimed tile is still first and can
           therefore never be the one dropped by the slice (the F7 half that was
           never about taste), the pointer's tile comes next, and the rest is
           still ranked on distance to the middle of the viewport. At cap 1 this
           comparator reproduces the old cascade exactly. */
        wanted = scored
          .filter((row) => row.seen >= VISIBLE_MIN)
          .sort((a, b) => {
            if (lead(a) !== lead(b)) return lead(a) ? -1 : 1;
            if (a.item.claimed !== b.item.claimed) return a.item.claimed ? -1 : 1;
            if (hot(a) !== hot(b)) return hot(a) ? -1 : 1;
            return a.off - b.off;
          })
          .slice(0, cap)
          .map((row) => row.item);
      }

      /* Resting is immediate: a slide that left the screen must stop paying for
         itself now. Starting waits, see DWELL. */
      this.loops.forEach((item) => {
        if (wanted.indexOf(item) === -1) this.rest(item);
      });

      /* The key is what stops the timer from being reset on every intersection
         callback: while the same slides stay chosen, the countdown runs once.
         SORTED, so the key describes the SET and not the ranking: with more than
         one slot the comparator above re-orders the same three tiles every time
         the pointer moves within the row, and an order sensitive key would have
         cleared a pending start on each of those moves. A visitor sweeping the
         pointer across the row would then have kept resetting DWELL and the
         third tile would never have started. */
      const key = wanted
        .map((item) => this.loops.indexOf(item))
        .sort((a, b) => a - b)
        .join(',');
      if (key === this.armed) return;
      this.armed = key;
      clearTimeout(this.wait);
      if (!wanted.length) return;
      this.wait = setTimeout(() => wanted.forEach((item) => this.start(item)), DWELL);
    }

    start(item) {
      item.frame.setAttribute('data-video-ambient-playing', '');
      if (!item.video.paused) return;
      const started = item.video.play();
      /* A refused autoplay must put the play control back rather than leave a
         still frame that looks like a broken video. */
      if (started) {
        started.catch(() => item.frame.removeAttribute('data-video-ambient-playing'));
      }
    }

    /* Paused AND rewound: a loop left at 8 s keeps its buffer warm for a slide
       nobody is looking at, and a feed restarts its videos from the top anyway.
       Sound never follows a slide off screen, so leaving releases the claim. */
    rest(item) {
      item.frame.removeAttribute('data-video-ambient-playing');
      if (item.claimed) this.mute(item);
      if (item.video.paused && !item.video.currentTime) return;
      item.video.pause();
      /* currentTime on a player that has not loaded metadata yet throws in some
         engines, and there is nothing to rewind in that state anyway. */
      if (item.video.readyState) item.video.currentTime = 0;
    }

    /* ---- sound ---------------------------------------------------------- */

    hear(item) {
      if (item.claimed) {
        this.mute(item);
        this.pick();
        return;
      }
      this.loops.forEach((other) => {
        if (other !== item) this.mute(other);
      });
      item.claimed = true;
      item.video.muted = false;
      this.flag(item);
      this.pick();
    }

    mute(item) {
      item.claimed = false;
      item.video.muted = true;
      this.flag(item);
    }

    flag(item) {
      const button = item.frame.querySelector('[data-video-sound]');
      if (!button) return;
      button.setAttribute('aria-pressed', item.claimed ? 'true' : 'false');
      const label = button.getAttribute(item.claimed ? 'data-label-mute' : 'data-label-unmute');
      if (label) button.setAttribute('aria-label', label);
    }

    /* ---- the centre ----------------------------------------------------- */

    /* Finds the reels, the dots and the arrows, and wakes the controls that
       ship hidden because they need this script. Reels that Liquid did not
       draw leave their dots behind, so the surplus is removed. */
    stage() {
      this.track = this.querySelector('[data-reel-track]');
      this.slides = this.track ? [...this.track.querySelectorAll('[data-reel]')] : [];
      this.center = Math.max(0, this.slides.findIndex((slide) => slide.getAttribute('data-reel-pos') === '0'));
      const row = this.querySelector('[data-reel-dots]');
      this.dots = row ? [...row.querySelectorAll('[data-reel-dot]')] : [];
      this.dots.slice(this.slides.length).forEach((dot) => dot.remove());
      this.dots = this.dots.slice(0, this.slides.length);
      const many = this.slides.length > 1;
      if (row) row.hidden = !many;
      this.querySelectorAll('[data-reel-prev], [data-reel-next]').forEach((arrow) => {
        arrow.hidden = !many;
      });
      if (this.track) this.track.addEventListener('scroll', this.onScroll, { passive: true });
      this.layout();
      this.fold();
    }

    /* Each reel's offset from the centre, wrapped round the ring so the
       stage always shows the same number of neighbours on each side. */
    layout() {
      const n = this.slides.length;
      const half = Math.floor(n / 2);
      this.slides.forEach((slide, index) => {
        const pos = ((index - this.center + n + half) % n) - half;
        slide.setAttribute('data-reel-pos', String(pos));
      });
      this.dots.forEach((dot, index) => {
        if (index === this.center) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
    }

    /* The reel whose middle is closest to the middle of the rail. */
    nearest() {
      if (!this.track || !this.slides.length) return -1;
      const box = this.track.getBoundingClientRect();
      const middle = box.left + box.width / 2;
      let best = -1;
      let gap = Infinity;
      this.slides.forEach((slide, index) => {
        const rect = slide.getBoundingClientRect();
        const off = Math.abs(rect.left + rect.width / 2 - middle);
        if (off < gap) {
          gap = off;
          best = index;
        }
      });
      return best;
    }

    /* Moves the centre. On the stage that is a change of offsets and CSS
       glides the reels; on the rail it is an instant scroll that the snap
       settles, never a scripted animation. */
    go(index) {
      const n = this.slides.length;
      if (!n) return;
      this.center = ((index % n) + n) % n;
      this.tapped = null;
      if (this.frame) this.stop();
      this.layout();
      if (!wide.matches && this.track) {
        const slide = this.slides[this.center];
        const box = this.track.getBoundingClientRect();
        const rect = slide.getBoundingClientRect();
        this.track.scrollLeft += rect.left + rect.width / 2 - (box.left + box.width / 2);
      }
      this.pick();
    }

    /* "more" only where the caption is actually cut. */
    fold() {
      this.querySelectorAll('[data-reel-caption]').forEach((caption) => {
        const more = caption.querySelector('[data-reel-more]');
        const text = caption.firstElementChild;
        if (!more || !text || caption.hasAttribute('data-open')) return;
        more.hidden = false;
        more.hidden = text.scrollWidth <= text.clientWidth;
      });
    }

    like(slide) {
      if (!slide) return;
      slide.setAttribute('data-reel-liked', '');
      slide.removeAttribute('data-reel-burst');
      void slide.offsetWidth;
      slide.setAttribute('data-reel-burst', '');
    }

    /* ---- the full player ------------------------------------------------ */

    press(event) {
      const target = event.target;
      if (!target || !target.closest) return;

      const dot = target.closest('[data-reel-dot]');
      if (dot && this.contains(dot)) {
        this.go(this.dots.indexOf(dot));
        return;
      }
      if (target.closest('[data-reel-prev]')) {
        this.go(this.center - 1);
        return;
      }
      if (target.closest('[data-reel-next]')) {
        this.go(this.center + 1);
        return;
      }
      const more = target.closest('[data-reel-more]');
      if (more && this.contains(more)) {
        const caption = more.closest('[data-reel-caption]');
        if (caption) caption.setAttribute('data-open', '');
        more.setAttribute('aria-expanded', 'true');
        return;
      }

      /* A press on a reel that is not the centre brings it to the centre; the
         reel's own controls wait until it is there. */
      const slide = target.closest('[data-reel]');
      const index = slide ? this.slides.indexOf(slide) : -1;
      if (index !== -1 && index !== this.center) {
        event.preventDefault();
        this.go(index);
        return;
      }

      const sound = target.closest('[data-video-sound]');
      if (sound && this.contains(sound)) {
        const item = this.loops.find((row) => row.frame.contains(sound));
        if (item) {
          event.preventDefault();
          this.hear(item);
        }
        return;
      }

      const closer = target.closest('[data-video-close]');
      if (closer && this.contains(closer)) {
        event.preventDefault();
        this.stop(true);
        return;
      }

      const trigger = target.closest('[data-video-play]');
      if (!trigger || !this.contains(trigger)) return;

      /* On a reel that is already looping, a pointer press is the feed's
         gesture, not a request for the full player: one press does nothing,
         two are a like. A key press (detail 0) keeps the link's promise and
         opens the player with sound. */
      const looping = trigger.closest('[data-video-ambient-playing]');
      if (looping && event.detail > 0) {
        event.preventDefault();
        const now = Date.now();
        if (this.tapped && this.tapped.frame === looping && now - this.tapped.at < DOUBLE_TAP) {
          this.tapped = null;
          this.like(looping.closest('[data-reel]'));
        } else {
          this.tapped = { frame: looping, at: now };
        }
        return;
      }

      const sources = fileSources(trigger.getAttribute('data-video-sources'));
      if (sources) {
        event.preventDefault();
        this.playFile(trigger, sources);
        return;
      }

      const src = embedSrc(trigger.getAttribute('href') || '');
      /* Nothing embeddable: the anchor keeps the destination it shipped with. */
      if (!src) return;
      event.preventDefault();
      this.play(trigger, src);
    }

    /* Mounts a player in the frame and takes the previous one down first: one
       player at a time is the rule for both kinds. Returns the frame, or null
       when the trigger sits in none. */
    mount(trigger, player) {
      const frame = trigger.closest('[data-video-frame]');
      if (!frame) return null;
      this.stop();

      /* Inserted BEFORE the close button, never appended: tab order is DOM
         order, and the only way out of a cross origin frame is the control
         that follows it. */
      const closer = frame.querySelector('[data-video-close]');
      if (closer) frame.insertBefore(player, closer);
      else frame.append(player);
      if (closer) closer.hidden = false;

      frame.setAttribute('data-video-playing', '');
      this.frame = frame;
      this.trigger = trigger;
      /* Every loop stops while a full player is up: two soundtracks in one row
         is the failure this whole file is arranged to prevent. */
      this.pick();
      return frame;
    }

    playFile(trigger, sources) {
      const held = document.activeElement === trigger;
      const frame = trigger.closest('[data-video-frame]');
      if (!frame) return;

      const host = document.createElement('div');
      host.className = 'video-slide__embed';
      const root = host.attachShadow({ mode: 'open' });
      const style = document.createElement('style');
      style.textContent = PLAYER_STYLE;

      const video = document.createElement('video');
      video.controls = true;
      video.playsInline = true;
      video.preload = 'none';
      video.autoplay = false;
      video.muted = false;
      video.loop = false;
      video.setAttribute('playsinline', '');
      /* LE LECTEUR PLEIN, LUI, A BESOIN D'UN POSTER: le sien couvre le cadre en
         `z-index: 6` et la feuille de style cache l'`<img>` sous lui
         (`[data-video-playing] .video-slide__poster { visibility: hidden }`), donc
         il n'y a rien dessous a laisser voir. Il lit d'abord le `currentSrc` de
         cette meme `<img>`, ce qui garantit un cache-hit a tout DPR et a toute
         largeur puisque c'est l'entree que le navigateur vient de telecharger; et
         a ce moment-la elle est resolue a coup sur, parce que le visiteur a du
         regarder la vignette pour la presser. `data-video-poster` reste le repli
         pour le cas ou elle ne le serait pas. */
      const poster = posterFor(frame, trigger);
      if (poster) video.poster = poster;
      video.setAttribute('aria-label', frame.getAttribute('data-video-title') || '');
      fill(video, sources);
      root.append(style, video);

      if (!this.mount(trigger, host)) return;
      this.video = video;

      /* The one play() this element ever gets, issued inside the visitor's own
         press. A browser that still refuses it leaves the native controls up,
         so the press is never lost. */
      const started = video.play();
      if (started) started.catch(() => {});
      if (held) video.focus({ preventScroll: true });
    }

    play(trigger, src) {
      const frame = trigger.closest('[data-video-frame]');
      if (!frame) return;
      const held = document.activeElement === trigger;

      const embed = document.createElement('iframe');
      embed.className = 'video-slide__embed';
      embed.src = src;
      embed.title = frame.getAttribute('data-video-title') || '';
      embed.allow = 'autoplay; encrypted-media; fullscreen; picture-in-picture';
      embed.setAttribute('allowfullscreen', '');
      embed.setAttribute('referrerpolicy', 'strict-origin-when-cross-origin');
      if (!this.mount(trigger, embed)) return;

      /* The play control is hidden while the frame is up, so a visitor who
         pressed it with a key would otherwise be dropped on the body. */
      if (held) embed.focus({ preventScroll: true });
    }

    /* `restore` hands focus back. It is right for Escape and for the close
       button, and wrong for a slide scrolling out of view: moving focus there
       would drag the page back to a row the visitor just left. preventScroll
       covers the case where focus was inside the frame we are removing. */
    stop(restore) {
      const frame = this.frame;
      const trigger = this.trigger;
      const video = this.video;
      this.frame = null;
      this.trigger = null;
      this.video = null;
      if (!frame) return;

      const held = frame.contains(document.activeElement);
      frame.removeAttribute('data-video-playing');
      /* Paused before removal, and emptied so no rendition keeps downloading
         for a player that no longer exists. */
      if (video) {
        video.pause();
        video.removeAttribute('src');
        [...video.querySelectorAll('source')].forEach((source) => source.remove());
        video.load();
      }
      const embed = frame.querySelector('.video-slide__embed');
      if (embed) embed.remove();
      const closer = frame.querySelector('[data-video-close]');
      if (closer) closer.hidden = true;

      if ((restore || held) && trigger && trigger.isConnected) {
        trigger.focus({ preventScroll: true });
      }
      /* The row goes back to looping the moment the full player is gone. */
      this.pick();
    }
  }

  customElements.define('pp-video-slider', VideoSlider);
})();
